import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/player-position-stacking/actions';
import InputCheckbox from 'components/atoms/inputs/input-checkbox';

class ForceSecondaryStack extends Component {
    onChange(isChecked) {
        this.props.dispatch(Action.set('SecondaryStackIsForced', isChecked));
    }

    render() {
        const {stacking} = this.props;
        const isChecked = stacking.isSecondaryStackForced();

        return <InputCheckbox label="Force secondary stack" checked={isChecked} onChange={::this.onChange} />;
    }
}

function mapStatesToProps(state) {
    const {playerPositionStacking} = state;

    return {
        stacking: playerPositionStacking,
    };
}

export default connect(mapStatesToProps)(ForceSecondaryStack);
